import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import _ from 'lodash';

export interface Model {
  title: string;
  data: any;
}

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css', '../../myreports.component.css']
})
export class BarChartComponent extends DialogComponent<Model, any> implements OnInit {

  title: string;
  data: any;
  public barChartData: any = {
      data: []
  };
  public options: any = {
    height: $(window).height() * 0.79,
    chartArea: {
      left: 160,
      top: 10,
      right: 200,
      width: '60%',
      height: '90%'
    },
    vAxis: {textStyle: {fontSize: 13}},
  };
  chartError = false;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.barChartData = this.data.chartData;
    this.options = _.merge(_.cloneDeep(this.data.options), this.options);
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/bar-chart/bar-chart.component.ts